<script>
  import Hero from "$lib/components/Hero/Hero.svelte";
  import Markdown from "$lib/components/Markdown.svelte";
  import PageBody from "$lib/components/Page/PageBody.svelte";
  import ItemPreviewList from "$lib/contentTypes/ItemPreviewList.svelte";
  import { formatDate } from "$lib/utilities/date";

  export let page;
  let closingText = page.fields.closingTextMarkdown;
</script>

<div class="w-full px-24 md:px-175 lg:max-w-1014 lg:px-0 m-auto">
  <div id="page-header">
    <Hero
      title={page.fields.pageData.fields.headline}
      byline={{
        publishDate: formatDate(
          page.fields.pageData?.fields.legacyPublishDate || page.sys.updatedAt
        )
      }}
      parentInfo={page.fields.pageData.fields.parentInfo}
    />
  </div>
  <div class="w-full page-level-padding">
    <article class="last-page-element">
      <PageBody body={page.fields.body} />
      {#if closingText}
        <Markdown input={closingText} class="pt-16 lg:pt-32" />
      {/if}
    </article>
  </div>

  {#if page.fields.trailingStoryLists}
    <div class="internal-page-spacing">
      {#each page.fields.trailingStoryLists as listData}
        <div>
          <!-- div added so that the gap doesn't double add spacing under the section header. -->
          <ItemPreviewList data={listData} />
        </div>
      {/each}
    </div>
  {/if}
</div>
